module.exports = __webpack_public_path__ + "static/media/logo-desktop-top.fa15287d.svg";